import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import "./../styles/admin.css"; // Import CSS file
import { Sidebar } from "../components/admin/sidebar";
import { AdminHeader } from "../components/admin/header";
import { useUser } from "../context/UserContext";
import { adminRoles } from "../utils";


const AdminLayout = () => {
  const { user } = useUser();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  if (!user?.role) {
    const redirectPath = `${location.pathname}${location.search || ""}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
  }

  if (!adminRoles.includes(user.role)) {
    return <Navigate to={'/unauthorized'} replace />;
  }


  return (
    <div className={`admin-container ${isSidebarOpen ? "admin-sidebar-open" : ""}`}>
      {/* Sidebar */}
          <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
          {isSidebarOpen && <button className="admin-sidebar-backdrop" onClick={() => setSidebarOpen(false)} aria-label="Đóng menu" />}

        {/* Main Content */}
        <div className="main-area">
            {/* Header */}
            <AdminHeader isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen}/>

            {/* Page Content */}
            <main className="admin-content">
                <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
